import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["form"]

  connect() {
    hideTarget(this.formTarget)
  }

  showForm(e) {
    e.preventDefault()
    showTarget(this.formTarget)
  }
}
